const initialState = {
    serviceTypePermissions:{},
    serviceTypeLists: [],
    serviceTypeStatus: [],
    changedServiceTypeStatus : [],
    loadingServiceType: false,
    errorsServiceType
: {}
}

const  serviceTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_SERVICETYPELIST_PENDING":
        case "ADD_SERVICE_TYPE_PENDING":
        case "UPDATE_SERVICE_TYPE_PENDING":
        case "UPDATE_SERVICE_TYPE_STATUS_PENDING":
        case "DELETE_SERVICE_TYPE_PENDING":
        case "GET_SERVICETYPELISTBYID_PENDING":
            return { ...state, loadingServiceType: true };

        case "GET_SERVICETYPELIST_FULFILLED":
            return {
                ...state,
                loadingServiceType: false,
                serviceTypeLists: action.payload,
                serviceTypeCount: action.serviceTypeCount,
                serviceTypePermissions:action.permissions,
            };

        case "ADD_SERVICE_TYPE_FULFILLED":
            return {
                ...state,
                loadingServiceType: false,
                changedServiceTypeStatus: action.payload,
            };

        case "UPDATE_SERVICE_TYPE_FULFILLED":
            return {
                ...state,
                loadingServiceType: false,
                changedServiceTypeStatus: action.payload,
            };

        case "UPDATE_SERVICE_TYPE_STATUS_FULFILLED":
            return {
                ...state,
                loadingServiceType: false,
                changedServiceTypeStatus: action.payload,
            };

        case "GET_SERVICETYPELISTBYID_FULFILLED":
            return {
                ...state,
                loadingServiceType: false,
                serviceTypeLists: action.payload
            };

        case "DELETE_SERVICE_TYPE_FULFILLED":
            return {
                ...state,
                loadingServiceType: false,
                changedServiceTypeStatus: action.payload
            };

        case "RESET_DELETE_SERVICE_TYPE_STATUS":
            return {
                ...state,
                loadingServiceType: false,
                changedServiceTypeStatus: [],
                errorsServiceType
:{}
            };

        case "GET_SERVICETYPELIST_REJECTED":
        case "ADD_SERVICE_TYPE_REJECTED":
        case "UPDATE_SERVICE_TYPE_REJECTED":
        case "UPDATE_SERVICE_TYPE_STATUS_REJECTED":
        case "DELETE_SERVICE_TYPE_REJECTED":
        case "GET_SERVICETYPELISTBYID_REJECTED":
            return {
                ...state,
                loadingServiceType: false,
                errorsServiceType
: action.payload
            };

        default:
            return state;
    }
}

export default serviceTypeReducer;